import {createRouter, createWebHistory} from 'vue-router';
import Index from "../views/IndexView.vue";
import News from "../views/NewsView.vue";
import ProductCenter from "../views/ProductCenterView.vue";
import CompanyProfile from "../views/CompanyProfileView.vue";
import factoryShow from "../views/FactoryShowView.vue";
import test from "../views/testView.vue";
import Contact from "../views/ContactUsView.vue";
import NewsDetail from "../views/NewsDetailView.vue";
import calPriceView from "../views/calPriceView.vue";

const routes = [
    {
        path: "/",
        name: "index",
        component: Index
    },
    {
        path: "/company_profile",
        name: "companyProfile",
        component: CompanyProfile
    },
    {
        path: "/news",
        name: "newsCenter",
        component: News
    },
    {
        path: "/product_center",
        name: "productCenter",
        component: ProductCenter
    },
    {
        path: "/factory_show",
        name: "factoryShow",
        component: factoryShow
    },    {
        path: "/test",
        name: "test",
        component: test
    },    {
        path: "/contact_us",
        name: "contactUs",
        component: Contact
    },
    {
        path: "/news_detail/:id",
        name: "NewsDetail",
        component: NewsDetail
    },
    {
        path: "/cal_price",
        name: "CalPrice",
        component: calPriceView
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return {top: 0}; // 每次路由跳转滚动到顶部
    },
});

export default router;
